export const FIVE_BY_FOUR_CROPPED_IMAGE_ONLY = '5:4-cropped-image-only';
export const NINE_BY_SIXTEEN_CROPPED_IMAGE_ONLY = '9:16-cropped-image-only';
export const NINE_BY_SIXTEEN_IMAGE_ONLY = '9:16-image-only';
export const TWO_BY_ONE_CROPPED_IMAGE_ONLY = '2:1-cropped-image-only';
export const TWO_BY_ONE_CROPPED_IMAGE_WITH_ORIGINAL =
  '2:1-cropped-image-with-original';
export const ONE_BY_ONE_CROPPED_IMAGE_ONLY = '1:1-cropped-image-only';
export const VIDEO_CLOUDINARY = 'video';
export const VIDEO_YOUTUBE = 'youtube';
